import resolveConfig from 'tailwindcss/resolveConfig';
import * as koopmansConfig from '../../../../../tailwind.koopmans.config';
import * as oetkerConfig from '../../../../../tailwind.oetker.config';

let textAreaIsHidden = false;

function hideTextArea() {
    textAreaIsHidden = true;

    const inputContainer = document.getElementById('voiceflow-chat').shadowRoot.querySelector('.vfrc-input-container');
    inputContainer.style.visibility = 'hidden';
    if (!inputContainer) {
        return;
    }
    const textArea = inputContainer.querySelector('textarea');
    textArea.disabled = true;
}

function showTextArea() {
    textAreaIsHidden = false;

    const inputContainer = document.getElementById('voiceflow-chat').shadowRoot.querySelector('.vfrc-input-container');
    inputContainer.style.visibility = 'visible';
    if (!inputContainer) {
        return;
    }
    const textArea = inputContainer.querySelector('textarea');
    textArea.disabled = false;
}

function listenToVoiceflowEvents() {
    let chatOpenCount = 0;
    let interactCount = 0;
    window.addEventListener('message', (event) => {
        let parsedEventData;
        let gtagPayloadEvent;
        try {
            parsedEventData = JSON.parse(event.data);
            // eslint-disable-next-line no-empty
        } catch (e) {
            return;
        }

        if (parsedEventData && parsedEventData.type) {
            switch (parsedEventData.type) {
            case 'voiceflow:open':
                if (chatOpenCount < 1) {
                    gtagPayloadEvent = { event: 'chat-open' };
                    hideTextArea();
                }
                chatOpenCount += 1;
                break;
            case 'voiceflow:interact':
                if (parsedEventData.payload && parsedEventData.payload.action && parsedEventData.payload.action.type === 'launch' && !textAreaIsHidden) {
                    hideTextArea();
                } else if (interactCount > 0 && textAreaIsHidden) {
                    showTextArea();
                }
                interactCount += 1;
                if (parsedEventData.payload
                        && parsedEventData.payload.action
                        && parsedEventData.payload.action.payload
                        && parsedEventData.payload.action.payload.label) {
                    gtagPayloadEvent = {
                        event: 'chat-button-click',
                        actionLabel: parsedEventData.payload.action.payload.label,
                    };
                }
                break;
            default:
                break;
            }
        }

        if (gtagPayloadEvent) {
            if (!window.dataLayer) {
                return;
            }
            window.dataLayer.push(gtagPayloadEvent);
        }
    }, false);
}

export default function initConversational() {
    const chatContainer = document.querySelector('[data-inova-contact-conversational]');
    if (!chatContainer) {
        return;
    }
    const site = chatContainer.getAttribute('data-inova-contact-conversational-site');
    const config = site === 'oetker' ? resolveConfig(oetkerConfig) : resolveConfig(koopmansConfig);
    const script = document.createElement('script');
    const lastScript = document.getElementsByTagName('script')[0];
    script.onload = () => {
        window.voiceflow.chat.load({
            autostart: true,
            assistant: {
                title: chatContainer.getAttribute('data-inova-contact-conversational-title'),
                color: config.theme.colors.primary['500'],
                image: chatContainer.getAttribute('data-inova-contact-conversational-image'),
                stylesheet: chatContainer.getAttribute('data-inova-contact-conversational-stylesheet'),
            },
            verify: { projectID: '67ffac703e46d6f4e9bd4548' },
            url: 'https://general-runtime.voiceflow.com',
            versionID: 'production',
            launch: {
                event: {
                    type: 'launch',
                    payload: {
                        site,
                        siteUrl: chatContainer.getAttribute('data-inova-contact-conversational-site-url'),
                    },
                },
            },
        }).then(() => {
            window.voiceflow.chat.proactive.clear();
            window.voiceflow.chat.proactive
                .push({ type: 'text', payload: { message: 'Chat nu met Lisa!' } });
            listenToVoiceflowEvents();
        });
    };
    script.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
    script.type = 'text/javascript';
    lastScript.parentNode.insertBefore(script, lastScript);
}
